import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage, buildSuccessMessage} from '../../common/util/errorUtils';

export const getItemBudget = (year) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': `/itemBudget/budget?year=${year}`,
      'authenticated': true,
      'types': [
        ActionTypes.FETCHING_ITEM_BUDGET,
        ActionTypes.FETCHED_ITEM_BUDGET,
        [ActionTypes.FETCHED_ITEM_BUDGET_FAILED, (error) => buildErrorMessage(error)],
      ],
      'microservice': 'part',
      'method': 'GET',
    })
  );
};

export const saveItemBudget = (data, year) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': `/itemBudget/budget?year=${year}`,
      'authenticated': true,
      'types': [
        ActionTypes.ADDING_ITEM_BUDGET,
        [
          () => {
            dispatch(getItemBudget(year));
            return {
              'type': ActionTypes.ADDED_ITEM_BUDGET,
            };
          },
          (response) => buildSuccessMessage(response, 'Registros Guardados'),
        ],
        [ActionTypes.ADDED_ITEM_BUDGET_FAILED, (error) => buildErrorMessage(error)],
      ],
      'microservice': 'part',
      'contentType': 'application/json',
      'method': 'POST',
      'data': data,
    })
  );
};

export const deleteItemBudget = () => ({
  'type': ActionTypes.DELETE_ITEM_BUDGET,
});
